import React from "react";
import { Box } from "@mui/material";
import { Header, Footer, DataMigration, AppBreadcrumbs } from "../common";
import { ShareActionProvider } from "../../contexts/ShareActionContext";

interface AppLayoutProps {
  children: React.ReactNode;
  currentPage:
    | "dashboard"
    | "expenses"
    | "income"
    | "debts"
    | "goals"
    | "accounts"
    | "transactions"
    | "trends"
    | "groups"
    | "tools"
    | "settings";
  apiConnected: boolean;
  onToggleApi: () => void;
  showMigration: boolean;
  onMigrationComplete: () => void;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  currentPage,
  apiConnected,
  onToggleApi,
  showMigration,
  onMigrationComplete,
}) => {
  console.log("App layout render", {
    currentPage,
    apiConnected,
    showMigration,
  });

  return (
    <ShareActionProvider>
      <Box
        sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        {/* Header */}
        <Header
          currentPage={currentPage}
          apiConnected={apiConnected}
          onToggleApi={onToggleApi}
        />

        {/* API Connection Status Banner */}
        {!apiConnected && (
          <div
            style={{
              backgroundColor: "#E53E3E",
              color: "white",
              padding: "12px 0",
              textAlign: "center",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                maxWidth: "1200px",
                margin: "0 auto",
                padding: "0 16px",
              }}
            >
              ⚠️ API Server Disconnected - Data may not load properly. Please
              check your connection.
            </div>
          </div>
        )}

        {/* Migration Overlay */}
        {showMigration && (
          <DataMigration onMigrationComplete={onMigrationComplete} />
        )}

        <AppBreadcrumbs />

        {/* Page Content */}
        <Box component="main" sx={{ flex: 1 }}>
          {children}
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </ShareActionProvider>
  );
};

export default AppLayout;
